import { Headers, Method, callFetch } from ".";
import { ApplicationState } from "../../nissan_no";

export const getPayload = (state: ApplicationState) => {
    const vin = state.vehicle?.VINNo.value;
    return JSON.stringify({
        chassisNumber: vin,
    });
};


const putChassisNumberToQuote = async (state: ApplicationState): Promise<ApplicationState> => {
    const { apiHost, quoteId } = state.inputs;

    if (!apiHost) {
        throw Error("API HOST ERROR");
    }

    if (!state.inputs.partner) {
        throw Error("PARTNER ERROR");
    }
    const payload = getPayload(state);

    const qid = { quoteId: quoteId ?? "" };
    Object.assign(Headers, qid);

    const fetchBuilder = () =>
        fetch(`${apiHost}/api/no/${state.inputs.partner}/addChassisNoToQuote`, {
            method: Method,
            mode: "cors",
            headers: Headers,
            body: payload,
        });

    const response = await callFetch(fetchBuilder);

    const json = await response.json();

    if (response.status !== 200) {
        throw Error((json && json.message) ?? "SERVER ERROR");
    }

    return {
        ...state,
    } as ApplicationState;
};

export default putChassisNumberToQuote;
